module.exports = __webpack_public_path__ + "assets/img/icon-prize.3d2fe726.png";